import { ACCESS_REFRESH_TOKEN } from "@/constants/access-refresh-token";

export const setRefreshToken = (refreshToken: string) => {
    localStorage.setItem(ACCESS_REFRESH_TOKEN, refreshToken);
};
